<template>
  <el-card :class="{ 'is-collapsed': isCollapsed }" class="mailbox-settings-collapsible-card">
    <template #header>
      <div
        :aria-expanded="isCollapsed ? 'false' : 'true'"
        class="mailbox-settings-collapsible-card__header"
        role="button"
        tabindex="0"
        @click="toggle"
        @keydown.enter.prevent="toggle"
        @keydown.space.prevent="toggle"
      >
        <h3>{{ title }}</h3>
        <i :class="{ 'is-active': !isCollapsed }" class="ddi ddi-caret-down mailbox-settings-collapsible-card__arrow" />
      </div>
    </template>
    <slot />
  </el-card>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* A settings card whose header shows or hides its contents */
export default defineComponent({
  name: 'MailboxSettingsCollapsibleCard',

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isCollapsed: false,
    }
  },

  methods: {
    toggle(): void {
      this.isCollapsed = !this.isCollapsed
    },
  },
})
</script>

<style lang="scss">
.mailbox-settings-collapsible-card {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    user-select: none;

    h3 {
      margin-bottom: 0;
    }
  }

  /* Matches the integrations accordion: points down when collapsed, up when open */
  &__arrow {
    color: var(--color-text-third);
    font-size: 14px;
    transition: transform 0.3s;

    &.is-active {
      transform: rotate(-180deg);
    }
  }

  &.is-collapsed {
    .el-card__header {
      border-bottom: none;
    }

    .el-card__body {
      display: none;
    }
  }
}
</style>
